<template>
  <section v-if="nearbyNodes?.length" class="section">
    <div class="container">
      <div class="mb-section-y">
        <h2 class="title is-h3">
          {{ $texts('nearbyNodes') }}
        </h2>
      </div>
      <div class="teaser-grid is-TeaserQuarter is-scrollable-mobile">
        <div class="teaser-grid-inner">
          <div
            v-for="item in nearbyNodes"
            :key="item.node?.teaserTitle"
            class="relative"
          >
            <TeaserQuarter
              :title="item.node?.teaserTitle"
              :url="item.node?.url?.path"
              :media="item.node?.teaserImage"
              :tagline="getFormattedDistance(item.distance)"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { notNullish } from '@vueuse/core'
import { filterNullArray, formatDistance } from '~/helpers'

const props = defineProps<{
  nid: string
}>()

const { $texts } = useEasyTexts()
const language = useCurrentLanguage()

const { data: nearbyNodes } = await useAsyncGraphqlQuery(
  'nearbyNodes',
  {
    id: props.nid,
    language: language.value,
  },
  {
    transform(data) {
      const node = data.data.node
      if (node && 'nearby' in node) {
        return filterNullArray(node.nearby)
      }
      return []
    },
    graphqlCaching: {
      client: true,
    },
    deep: false,
    watch: [language],
  },
)

function getFormattedDistance(distance?: number) {
  if (notNullish(distance)) {
    return formatDistance(distance)
  }
}
</script>
